import { Typography } from '@/components/common';
import { StatusCleanupWizard } from '@/interfaces';
import clsx from 'clsx';
import { format } from 'date-fns';

interface StatusTableColumnProps {
	status: StatusCleanupWizard;
	date: string | null;
}

export const StatusTableColumn: React.FC<StatusTableColumnProps> = ({
	status,
	date,
}) => {
	return (
		<div>
			<Typography
				type="regular-14"
				className={clsx(
					{ 'text-main-red': status === 'Review Required' },
					{ 'text-main-red': status === 'Contact Customer' },
					{ 'text-grey-70': status === 'Deactivate Account' }
				)}
			>
				{status === 'Deactivate Account' ? 'Deactivated Account' : status}
			</Typography>
			{date && (
				<Typography type="regular-12" className="text-grey-50">
					{format(new Date(date), 'MMMM d, yyyy')}
				</Typography>
			)}
		</div>
	);
};
